import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@material-ui/core'
import { AxiosError } from 'axios'
import { postgraduatePromoBannerLenovo } from 'src/assets/images'
import { webApi } from 'src/services/api/config'
import subscriptionClosed from 'src/services/time'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import SubscribeForm from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/Forms/SubscriptionFormFields'
import SendFilesForm from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/Forms/SubscriptionDocumentsForm'
import FormSent from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/Forms/SubscriptionSuccess'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostgraduateEnrollment.styles'

const PostGraduateSubscriptionOpen = () => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const { t } = useTranslation()

  const [formSent, setFormSent] = useState(false)
  const [err, setErr] = useState(<></>)

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    const formData = new FormData(event.target)

    const submitBtn = document.getElementById(
      'submit-sub-form'
    ) as HTMLButtonElement

    if (submitBtn) {
      submitBtn.innerHTML = 'ENVIANDO...'
      submitBtn.style.background = 'gray'
      submitBtn.disabled = true
    }

    subscriptionClosed().then((closed) => {
      if (closed) {
        document.getElementById('sub-form-id-anchor')?.scrollIntoView()
        setErr(<span>Inscrições encerradas.</span>)
        submitBtn.innerHTML = 'REALIZAR A INSCRIÇÃO'
        submitBtn.style.background = '#fec074'
        submitBtn.disabled = false
      } else {
        webApi
          .post('/api/site/postgraduate/subscriptions/cybersec', formData, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then(() => {
            document.getElementById('title-anchor')?.scrollIntoView()
            setFormSent(true)
          })
          .catch((err: AxiosError) => {
            document.getElementById('sub-form-id-anchor')?.scrollIntoView()

            if (err.response?.status === 400) {
              setErr(<span>Inscrição já cadastrada ou dados incorretos.</span>)
            } else {
              setErr(
                <span>
                  Não foi possível realizar a sua inscrição. Por favor, entre em
                  contato com nosso suporte ou tente novamente mais tarde.
                </span>
              )
            }

            submitBtn.innerHTML = 'REALIZAR A INSCRIÇÃO'
            submitBtn.style.background = '#7316de'
            submitBtn.disabled = false
          })
      }
    })
  }

  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            { label: 'Home', path: '/news/home' },
            { label: 'Pós-Graduação', path: '/postgraduate' },
            { label: 'Inscrição' }
          ]}
        />
      </Box>
      <Box>
        <Typography
          variant="h1"
          id="title-anchor"
          className={globalClasses.titleSection}
        >
          {t('news.postgraduate.sub.page-title')}
        </Typography>
        <img
          src={postgraduatePromoBannerLenovo}
          alt="Residência em Segurança Cibernética"
          style={{ width: '100%', marginTop: '1.5rem' }}
        />
      </Box>
      {!formSent && (
        <>
          <Box style={{ marginBottom: '2rem' }}>
            <p>
              <strong>Período</strong>: 04 de abril de 2022 a 22 de abril de
              2022 <strong>(Inscrições prorrogadas)</strong>
            </p>

            <Box className={classes.warning}>
              <Box className={classes.warningTitle}>Aviso!</Box>
              <p>
                Devido a problemas técnicos ocorridos no sistema de inscrição da
                UFC, o candidato que não conseguir realizar a inscrição pelo
                SIGAA, poderá ainda sim realizar a inscrição pelo nosso site,
                sem a necessidade de envio do comprovante do SIGAA.
              </p>
            </Box>
            <p>
              A seleção para a Residência em Segurança Cibernética é ofertada no
              formato de Pós-Graduação Lato Sensu (Especialização) na modalidade
              de educação presencial, sob o fomento da Lenovo Brasil.
            </p>
            <p>
              <strong>Importante</strong>: Primeiramente, o candidato deverá
              realizar a inscrição pela ferramenta SIGAA, através{' '}
              <a
                href="https://si3.ufc.br/sigaa/public"
                target="_blank"
                rel="noopener noreferrer"
              >
                desse link
              </a>
              . Após isso, deverá preencher o formulário abaixo corretamente. No
              final, o candidato poderá realizar envio dos seus documentos.
            </p>
          </Box>
          <Box>
            <form
              method="POST"
              name="subscribe-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <SubscribeForm errorMessage={err} />
              <Box className={classes.separator} />
              <SendFilesForm />
              <Box className={classes.legendContainer}>
                <small className={classes.legend}>
                  * Campos de preenchimento obrigatório.
                </small>
              </Box>
              <Box className={classes.buttonGroup}>
                <Box className={classes.buttonContainer}>
                  <button
                    id="submit-sub-form"
                    type="submit"
                    className={classes.submitButton}
                  >
                    REALIZAR A INSCRIÇÃO
                  </button>
                </Box>
              </Box>
            </form>
          </Box>
        </>
      )}
      {formSent && (
        <Box>
          <FormSent />
        </Box>
      )}
    </Box>
  )
}

export default PostGraduateSubscriptionOpen
